document.addEventListener("DOMContentLoaded", function () {

  (() => {
    const canvases = document.querySelectorAll('canvas.js-chart');
    if (!canvases.length) return;

    const instances = new WeakMap();

    const createChart = (canvas) => {
      if (instances.has(canvas)) return;

      const values = JSON.parse(canvas.dataset.values || '[]');
      const colors = JSON.parse(canvas.dataset.colors || '[]');

      // 色が足りない場合は自動補完（任意）
      const defaultPalette = [
        '#1e2083',
        '#285ebf',
        '#54b9c4',
        '#cccccc'
      ];

      const bgColors = values.map((_, i) =>
        colors[i] || defaultPalette[i % defaultPalette.length]
      );

      const ctx = canvas.getContext('2d');

      const chart = new Chart(ctx, {
        type: 'pie',
        data: {
          datasets: [{
            data: values,
            backgroundColor: bgColors,
            borderColor: '#ffffff',
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false }
          },
          animation: {
            duration: 1600,
            easing: 'easeOutCubic',
            animateRotate: true
          }
        }
      });

      instances.set(canvas, chart);
    };

    if (!('IntersectionObserver' in window)) {
      canvases.forEach(createChart);
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        createChart(entry.target);
        io.unobserve(entry.target);
      });
    }, {
      threshold: 0.35
    });

    canvases.forEach((c) => io.observe(c));
  })();


  // const ctx = document.getElementById('myChart').getContext('2d');
  // const myChart = new Chart(ctx, {
  //     type: 'pie',
  //     data: {
  //         datasets: [{
  //             data: [57.8, 29.1, 12.8,0.3],
  //             backgroundColor: [
  //                 'rgba(30, 32, 131, 1)',
  //                 'rgba(40, 94, 191, 1)',
  //                 'rgba(84, 185, 196, 1)',
  //                 'rgba(204, 204, 204, 1)'
  //             ],
  //             borderColor: [
  //                 'rgba(255, 255, 255, 1)',
  //                 'rgba(255, 255, 255, 1)',
  //                 'rgba(255, 255, 255, 1)',
  //                 'rgba(255, 255, 255, 1)'
  //             ],
  //             borderWidth: 1
  //         }]
  //     },
  //     options: {
  //         // radius: '100%',
  //         responsive: true,
  //         maintainAspectRatio: false,
  //         plugins: {
  //           legend: { display: false }
  //         },
  //         animation: {
  //             duration: 1400,
  //             easing: 'easeOutCubic',
  //             animateRotate: true
  //         },
  //     }
  // });

  function countUpExcute(_target){

    const DEFAULT_DURATION = 1000;
    const DEFAULT_COMMA = false;

    _target.querySelectorAll('.js-countup-num').forEach((el) => {
      const rawNum = el.dataset.num ?? '0';
      const parsed = Number(rawNum);
      const toNum = Number.isFinite(parsed) ? parsed : 0;

      const duration = Number(el.dataset.duration) || DEFAULT_DURATION;

      // ★ 追加：開始遅延（秒） -> ミリ秒
      const delaySec = Number(el.dataset.delay) || 0;
      const delayMs = Math.max(0, delaySec * 1000);

      const comma =
        el.dataset.comma != null
          ? /^(1|true|yes)$/i.test(el.dataset.comma)
          : DEFAULT_COMMA;

      let decimals;
      if (el.dataset.decimals != null) {
        decimals = Math.max(0, Number(el.dataset.decimals) || 0);
      } else {
        const decPart = rawNum.split('.')[1];
        decimals = decPart ? decPart.length : 0;
      }

      const format = (n) => {
        if (!Number.isFinite(n)) {
          return decimals > 0 ? Number(0).toFixed(decimals) : '0';
        }

        const fixedStr = decimals > 0
          ? n.toFixed(decimals)
          : String(Math.floor(n));

        if (!comma) return fixedStr;

        const [intPart, decPart] = fixedStr.split('.');
        const intWithComma = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return decPart != null ? `${intWithComma}.${decPart}` : intWithComma;
      };

      // ===== 最終文字列を基準に span 構築 =====
      const finalStr = format(toNum);
      const charCount = finalStr.length;

      el.innerHTML = '';
      const spans = [];

      for (let i = 0; i < charCount; i++) {
        const ch = finalStr[i];
        const s = document.createElement('span');
        s.classList.add('count-char');

        if (/\d/.test(ch)) {
          s.classList.add('is-digit');
          s.classList.add(`is-digit-${ch.padStart(2, '0')}`);
        } else if (ch === ',') {
          s.classList.add('is-comma');
        } else if (ch === '.') {
          s.classList.add('is-dot');
        } else {
          s.classList.add('is-space');
        }

        s.textContent = '0';
        el.appendChild(s);
        spans.push(s);
      }

      const render = (str) => {
        const padded = String(str).padStart(charCount, ' ');

        for (let i = 0; i < charCount; i++) {
          const ch = padded[i];
          spans[i].textContent = ch === ' ' ? '' : ch;
        }
      };

      // 初期表示
      render(format(0));

      let start = null;
      const tick = (now) => {
        if (start == null) start = now;

        const elapsed = now - start;

        // ★ 追加：delay時間は0表示のまま待機
        if (elapsed < delayMs) {
          requestAnimationFrame(tick);
          return;
        }

        // delay分を差し引いた時間でアニメ進捗を計算
        const animElapsed = elapsed - delayMs;
        const t = Math.min(animElapsed / duration, 1);
        const current = toNum * t;

        render(format(current));

        if (t < 1) requestAnimationFrame(tick);
        else render(finalStr);
      };

      requestAnimationFrame(tick);
    });

  }


  const dataElems = document.querySelectorAll('.js-data-con')
  dataElems.forEach((dataElem) => {
    ScrollTrigger.create({
      trigger: dataElem,
      start: '0 95%',
      markers: false,
      onEnter: () => {
        if(!dataElem.classList.contains('is-animate')){
          setTimeout(function () {
            countUpExcute(dataElem)
            dataElem.classList.add('is-animate')
          }, 500) //300
        }
      },
    })
  });
});
